import {Injectable} from '@angular/core';
import {catchError, map} from 'rxjs/operators';
import {ApiService} from './api.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable, pipe, throwError} from 'rxjs';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

declare function initPluginSign(comp): any;

declare function getSessionId(): string;

const routes = {
  getSession: '/getSession',
  getCert: '/getCert',
  signHash: '/signHash',
};

@Injectable({
  providedIn: 'root'
})
export class UsbTokenService {
  @BlockUI() blockUI: NgBlockUI;
  private subscribeSesstionId: BehaviorSubject<string>;
  private subscribeCert: BehaviorSubject<any>;
  private subscribeSignature: BehaviorSubject<any>;

  BASE_URL = 'http://127.0.0.1:19650';

  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    })
  };

  constructor(
    private apiService: ApiService,
    private httpClient: HttpClient,
  ) {
    this.subscribeSesstionId = new BehaviorSubject<string>('');
    this.subscribeCert = new BehaviorSubject<any>(null);
    this.subscribeSignature = new BehaviorSubject<any>(null);
  }

  subscribeSessionId() {
    return this.subscribeSesstionId.asObservable();
  }

  getSubscribeCert() {
    return this.subscribeCert.asObservable();
  }

  getSubscribeSignature() {
    return this.subscribeSignature.asObservable();
  }

  setSessionId(sessionId) {
    this.subscribeSesstionId.next(sessionId);
  }

  setCert(cert) {
    this.subscribeCert.next(cert);
  }

  setSignature(signature) {
    this.subscribeSignature.next(signature);
  }
  //
  // async testWorker() {
  //   if (typeof Worker !== 'undefined') {
  //     const worker = new Worker('../worker/usb-token.worker', {type: 'module'});
  //     worker.onmessage = ({data}) => {
  //       console.log(`page got message: ${data}`);
  //       this.subscribeSesstionId.next('22353647890');
  //     };
  //     worker.postMessage('d�y l� sessionid');
  //   }
  // }

  // async workerGetSession() {
  //   if (typeof Worker !== 'undefined') {
  //     const worker = new Worker('../worker/usb-token.worker', {type: 'module'});
  //     worker.onmessage = ({data}) => {
  //       // return data;
  //       this.subscribeSesstionId.next(data);
  //     };
  //     // const sessionId = getSessionId();
  //     worker.postMessage('');
  //   }
  // }

  // workerGetCert() {
  //   if (typeof Worker !== 'undefined') {
  //     const worker = new Worker('../worker/usb-get-cert.worker', {type: 'module'});
  //     worker.onmessage = ({data}) => {
  //       this.setCert(data);
  //     };
  //     worker.postMessage(null);
  //   }
  // }
  //
  // workerSignHash(comp, hash, hSession, serialNumber) {
  //   // this.blockUI.reset();
  //   // this.blockUI.start('');
  //   if (typeof Worker !== 'undefined') {
  //     const worker = new Worker('../worker/usb-sign-hash.worker', {type: 'module'});
  //     worker.onmessage = ({data}) => {
  //       this.setSignature(data);
  //       this.blockUI.stop();
  //     };
  //     worker.postMessage({hash, hSession, serialNumber});
  //   }
  // }

  // async workerGetCert

  initPlugin() {
    return this.httpClient
      .post(`${this.BASE_URL}${routes.getSession}`, null, this.options)
      .pipe(catchError(this.formatErrors));
  }

  getCert(sessionId: string) {
    const formData = new URLSearchParams();
    formData.set('sessionId', sessionId);
    return this.httpClient
      .post(`${this.BASE_URL}${routes.getCert}`, formData, this.options)
      .pipe(catchError(this.formatErrors));
  }

  signHash(body) {
    // body:{
    //   sessionId, serialNumber, hashBase64
    // }
    const formData = new URLSearchParams();
    for (const [key, value] of Object.entries(body)) {
      if (typeof value === 'string') {
        formData.set(key, value);
      }
    }
    return this.httpClient
      .post(`${this.BASE_URL}${routes.getCert}`, formData, this.options)
      .pipe(catchError(this.formatErrors));
  }

  public formatErrors(error: any): Observable<any> {
    return throwError(error.error);
  }
}
